import { useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isAnyPermitted, isPermitted } from "util/PermissionsMixin";
const useAuthorizedColumnSchemas = (columnSchemas) => {
  const currentUser = useCurrentUser();
  return useMemo(
    () => columnSchemas.filter(({ permissions, anyPermissions, hidden }) => {
      if (hidden) {
        return false;
      }
      if (permissions == null ? void 0 : permissions.length) {
        return anyPermissions ? isAnyPermitted(currentUser.permissions, permissions) : isPermitted(currentUser.permissions, permissions);
      }
      return true;
    }),
    [columnSchemas, currentUser.permissions]
  );
};
export default useAuthorizedColumnSchemas;
